<template lang="pug">
  .page
    section
      b-container
        h1 Getting started on Wall
        // h4 Can't find what you're looking for?
        // b-button.btn-outline
          router-link(:to="{name:'contact'}")
            // i.fa.fa-chevron-right.mr-2
            span Contact Us
        div.pt-3.faq-group(role='tablist', v-for='question in questions', :key="question.id")
          hr
          a.faq-tile(href='#', v-b-toggle="'accordion-' + question.id", variant='primary')
            .mr-3.fa.fa-plus
            span {{ question.title }}
          b-collapse(v-bind:id="'accordion-'+question.id", accordion='my-accordion', role='tabpanel')
            p.card-text.mt-3 {{question.text}}
</template>

<script>

import standardMix from '@/mixins/standardMix';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      questions: [
        { id: '1',
          title: 'How do I upload my art?',
          text: 'This is an answer to that question' },
        { id: '2',
          title: 'What happens once I sell a piece?',
          text: 'This is a good answer to that good question' },
        { id: '3',
          title: 'What fees will I be charged?',
          text: 'This is an even better answer to that even better question' },
        { id: '4',
          title: 'How should I package my art?',
          text: 'This is a good answer to that good question' },
        { id: '5',
          title: 'How does a rental work?',
          text: 'This is a good answer to that good question' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .faq-group{
    width: 100%;
    .faq-tile{
      // color: $primary;
      display: block;
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Help.vue